import React from 'react';
import { useTranslation } from 'react-i18next';
import { Calendar } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Badge } from '../ui/badge';
import { getStatusInfo } from './payrollExportsHelpers';
import { useCurrencyFormatter } from '../../hooks/usePayrollFormatters';

const PayrollExportsPeriodCard = ({ selectedPeriod }) => {
  const { t, i18n } = useTranslation();
  const statusInfo = getStatusInfo(selectedPeriod.status);
  const fmt = useCurrencyFormatter();
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Calendar className="h-5 w-5" />
          {t('payrollExp.periodCard')}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex items-center justify-between">
          <div>
            <h4 className="font-semibold text-lg">{selectedPeriod.description || t('payrollExp.defaultDesc')}</h4>
            <p className="text-muted-foreground">
              {t('payrollExp.periodRange', {
                start: new Date(selectedPeriod.start_date).toLocaleDateString(i18n.language),
                end: new Date(selectedPeriod.end_date).toLocaleDateString(i18n.language),
              })}
            </p>
          </div>
          <div className="text-right">
            <Badge variant={statusInfo.variant} className="mb-2">{t(statusInfo.labelKey)}</Badge>
            <p className="text-sm text-muted-foreground">{t(statusInfo.descKey)}</p>
          </div>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-6">
          <div className="text-center">
            <p className="text-2xl font-bold">{selectedPeriod.total_employees || 0}</p>
            <p className="text-sm text-muted-foreground">{t('payrollExp.employees')}</p>
          </div>
          <div className="text-center">
            <p className="text-2xl font-bold">{fmt(selectedPeriod.total_gross_amount)}</p>
            <p className="text-sm text-muted-foreground">{t('payrollExp.totalGross')}</p>
          </div>
          <div className="text-center">
            <p className="text-2xl font-bold">{fmt(selectedPeriod.total_deductions)}</p>
            <p className="text-sm text-muted-foreground">{t('payrollExp.deductions')}</p>
          </div>
          <div className="text-center">
            <p className="text-2xl font-bold text-green-600">{fmt(selectedPeriod.total_net_amount)}</p>
            <p className="text-sm text-muted-foreground">{t('payrollExp.netToPay')}</p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default PayrollExportsPeriodCard;
